/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateEntity } from './candidate-entity';
import { OpportunityEntity } from './opportunity-entity';
export class CandidatesSavedOpportunityEntity extends Entity {
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  updatedAt: string | null = null;
  static override key = 'CandidatesSavedOpportunity';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      opportunity: OpportunityEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidatesSavedOpportunity' in input
    ) {
      const { CandidatesSavedOpportunity: wrapped, ...rest } = input as {
        CandidatesSavedOpportunity: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}